/* eslint-disable max-classes-per-file */
import { Path } from 'react-hook-form';

import { ApiClientError } from './ApiClientError';

export class KlokhuisError<
  DataType extends object = object,
> extends ApiClientError<DataType> {
  override name = 'KlokhuisError';
}

export class KlokhuisValidationError<PayloadType> extends KlokhuisError<{
  errors: {
    key: Path<PayloadType>;
  }[];
}> {
  override name = 'KlokhuisValidationError';
}
